<template>
  <page-option
    disable-add
    overflow-hidden
    titleIcon="mdi-access-point-network"
    :title="$t('sidebar.permissions.name')"
  >
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        :disableCreate="true"
        placeholder="Tìm kiếm theo tên hiển thị"
      >
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params.sync="params"
        :defaultParams="default_params"
        sync-params
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span>
            {{ item.created_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>
            {{ item.updated_at | dateTime('short') }}
          </span>
        </template>
      </base-serve-table>
    </v-sheet>
  </page-option>
</template>

<script>
import { API_PERMISSION } from '@api'
import { EDIT_TYPE } from '@constant'
import FilterSearch from '@layouts/filter-search.vue'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
export default {
  mixins: [],
  components: {
    FilterSearch,
  },
  props: { option: { type: Object, default: () => ({ params: {} }) } },
  data: (vm) => ({
    default_params: { with: '' },
    params: { search: '', inactive: null },

    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'display_name',
      },
      {
        trans: 'field.updated_at',
        align: 'start',
        sortable: true,
        width: '150px',
        value: 'updated_at',
      },
      {
        trans: 'field.created_at',
        align: 'start',
        width: '150px',
        value: 'created_at',
      },
    ],
    loading: false,
  }),
  watch: {},
  computed: {
    api() {
      return API_PERMISSION
    },
  },
  created() {},
  mounted() {},
  methods: {
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.name },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_PERMISSION.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    // onCreateItem() {
    //   this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    // },
    // onUpdateItem(item) {
    //   this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    // },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
